// extracted by mini-css-extract-plugin
export default {"container":"TitleContainer_container__nXYRR","headerContainer":"TitleContainer_headerContainer__2blmh","title":"TitleContainer_title__9zz-i","data":"TitleContainer_data__ZA5MJ"};